import React, { useContext, useState } from "react";

import { ALL_BOOKING_CODES_QUERY } from "../../../graphql/BookingCodes/BookingCodes.graphql";

import {
  AddBookingCodeForm,
  EditBookingCodeForm
} from "../../../components/BookingCodes";

import { ModalContext } from "../../../components/ModalProvider";

import DataTable from "../../../components/DataTable";

import { COLUMNS } from "./columns";
import PageHeader from "../../../components/PageHeader";

import BookingCodeFilters from "./BookingCodeFilters";
import { getFilterState, saveFilterState } from "../../../utils";

const BookingCodesPage = () => {
  const INITIAL_FILTER_STATE = getFilterState("BOOKING_CODE_FILTERS", {
    Active: true
  });

  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const { setModalOpen } = useContext(ModalContext);
  const handleSetFilters = inputs => {
    saveFilterState("BOOKING_CODE_FILTERS", inputs);
    setFilters({ ...inputs });
  };

  const resetFilters = () => handleSetFilters({ Active: true });
  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={BookingCodeFilters}
        columns={COLUMNS}
        filters={filters}
        name="BookingCodes"
        query={ALL_BOOKING_CODES_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Booking Codes"
        onAddClick={() =>
          setModalOpen(
            true,
            <AddBookingCodeForm onComplete={() => setModalOpen(false, "")} />
          )
        }
      />
      <DataTable
        columns={COLUMNS}
        dataQuery={ALL_BOOKING_CODES_QUERY}
        initialSortBy={[{ id: "BookingCode", desc: false }]}
        name="BookingCode"
        where={filters}
        onRowClick={data =>
          setModalOpen(
            true,
            <EditBookingCodeForm
              bookingCode={data}
              onComplete={() => setModalOpen(false, "")}
            />
          )
        }
      />
    </React.Fragment>
  );
};

export default BookingCodesPage;
